export default __webpack_public_path__ + "static/media/gallery-wip-handle_04.dc40d7b0.jpg";